import { render } from "./BuzzUserRegister.vue?vue&type=template&id=1de81e6c&scoped=true"
import script from "./BuzzUserRegister.vue?vue&type=script&lang=js"
export * from "./BuzzUserRegister.vue?vue&type=script&lang=js"

import "./BuzzUserRegister.vue?vue&type=style&index=0&id=1de81e6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de81e6c"]])

export default __exports__